import React from 'react';
import { connect } from 'react-redux';
import * as classesActions from '../store/classes/actions';
import * as uiActions from '../store/ui/actions';
import * as reducers from '../store/reducers';

import SectionHeader from 'Components/SectionHeader';
import Button from 'Components/Button';
import SectionGroup from 'Components/SectionGroup';
import CollectionList from 'Components/CollectionList';
import CreateClassForm from 'Containers/CreateClassForm';
import Lightbox from 'Components/Lightbox';
import Loading from 'Components/Loading';
import SchoolCode from 'Containers/SchoolCode';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class ClassesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageLoading: true,
      classesRequested: false,
    };
  }

  setPageLoading(props) {
    if (
      !props.isFetchingClasses &&
      this.state.pageLoading &&
      this.state.classesRequested
    ) {
      this.setState({
        pageLoading: false,
      });
    }
  }

  requestClasses(props) {
    if (props.activeUser && !this.state.classesRequested) {
      this.setState(
        { classesRequested: true },
        this.props.fetchClassesForActiveUser
      );
    }
  }

  componentDidMount() {
    this.requestClasses(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setPageLoading(nextProps);
    this.requestClasses(nextProps);
  }

  render() {
    const { pageLoading } = this.state;
    const { classes, isModalActive } = this.props;
    if (pageLoading) return <Loading />;

    const createClassButton = (
      <Button
        label={
          <ConnectedFormattedMessage id="classes_page.create_button.label" />
        }
        labelExtension={
          <ConnectedFormattedMessage id="classes_page.create_button.label_extension" />
        }
        buttonType="secondary-mono"
        ctaIcon="plus"
        ctaIconBefore={true}
        clickHandler={() => this.props.showModal('create-class')}
      />
    );

    const headerButton = classes.length ? createClassButton : null;
    const actionButton = (
      <div className="SectionHeader__actions-grid">
        {headerButton}
        <SchoolCode />
      </div>
    );
    return (
      <main className="Page__content">
        <SectionGroup>
          <SectionHeader
            title={<ConnectedFormattedMessage id="classes_page.title" />}
            type="page-header"
            actionButton={actionButton}
          />
        </SectionGroup>
        {classes.length ? (
          <CollectionList items={classes} type="classes" />
        ) : (
          <SectionGroup additionalClasses=" SectionGroup--zero-state">
            {createClassButton}
          </SectionGroup>
        )}
        <Lightbox
          visible={isModalActive}
          closeHandler={() => this.props.hideModal('create-class')}
          type="create-class"
        >
          <SectionHeader
            title={
              <ConnectedFormattedMessage id="classes_page.create_class_modal.title" />
            }
          />
          <CreateClassForm inLightbox={true} />
        </Lightbox>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    classes: reducers.getClassesForActiveUser(state),
    isFetchingClasses: reducers.getIsFetchingClasses(state),
    activeUser: reducers.getActiveUser(state),
    isModalActive: reducers.isModalActive(state, 'create-class'),
  };
};

export default connect(mapStateToProps, {
  ...classesActions,
  ...uiActions,
})(ClassesPage);
